import React from 'react'

function Gaming() {
  return (
    <>
      <h1> I love Gaming. Call of Duty and Mortal Combat </h1>
    </>
  )
}

export default Gaming